export const FACEITEMAREALIMIT = 50000;

export const WINDFARMAREALIMIT = 5000;
